import type { ComponentTreeItem } from "@/entities/component-tree";
import type { DefectTree } from "@/entities/defect-tree";

export const extractDefectTreeComponentsKeys = (
  tree: DefectTree | ComponentTreeItem,
  key: string | null = null
): string[] => {
  let keys: string[] = [];

  if (Array.isArray(tree) && typeof tree[0] === "object") {
    return [
      ...keys,
      ...tree.flatMap((item) => extractDefectTreeComponentsKeys(item, key)),
    ];
  }

  if ("slug" in tree) {
    key = key === null ? tree.slug : `${key}.${tree.slug}`;
    keys.push(key);
  }

  if ("components" in tree) {
    keys = [
      ...keys,
      ...tree.components.flatMap((item) =>
        extractDefectTreeComponentsKeys(item, key)
      ),
    ];
  }

  return keys;
};
